import http from './http'; // Ensure this imports your configured Axios instance

const BASE_URL = '/articles';
const TENANT_ID = process.env.REACT_APP_TENANT_TITLE;

const getArticleListData = (queries, callback) => {
  http
    .get(`/tenant/${TENANT_ID}${BASE_URL}/${queries}`)
    .then((res) => callback({ payload: res.data, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const getArticleDetailData = (slug, callback) => {
  http
    .get(`/tenant/${TENANT_ID}${BASE_URL}/${slug}`)
    .then((res) => callback({ payload: res.data, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const getArticleTags = (callback) => {
  http
    .get(`/tenant/${TENANT_ID}${BASE_URL}/tags`)
    .then((res) => callback({ payload: res.data.data, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

export const SERVICE_ARTICLE = {
  getArticleListData,
  getArticleDetailData,
  getArticleTags,
};
